import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	skusWithOrderName: [],
};

const skusWithOrderNameSlice = createSlice({
	name: 'skusWithOrderName',
	initialState: initialState,
	reducers: {
		setSkusWithOrderName: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setSkusWithOrderName, reset } = skusWithOrderNameSlice.actions;

export default skusWithOrderNameSlice.reducer;